import { get, reduce } from 'lodash';
import { TMutationContext } from '../../../../hooks/useContexts/types';
import { TInputState } from '../types';
import { TBaseInputTag } from '../../types';
import mutator from '@krugom/mutator';

export const validateFormInput = (
  input: TInputState,
  context: Partial<TMutationContext>
): TInputState => {
  const validationSchema = (get(input, 'validation') as TBaseInputTag['validation']) || [];

  if (!validationSchema) return input;
  const newContext = {
    ...context,
    input,
  };
  const errors = validationSchema?.length
    ? reduce(
        validationSchema,
        (r, v) => {
          const isWrong = !!mutator.mutate.string(`<% ${v.isWrong} %>`, newContext);
          if (isWrong) return [...r, v.isWrongMessage];
          return [...r];
        },
        [] as string[]
      )
    : [];
  return {
    ...input,
    errors,
  };
};
